/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useLoginFields from './useLoginFields'
import Field from '../field'

const LoginFields = ({form, prefix = ''}) => {
    const fields = useLoginFields({form, prefix})
    const styles = useStyleConfig('FormStyles')
    return (
        <Stack {...styles.fieldsStack} className="login-fields-stack">
            <Field
                {...fields.email}
                eventAction="login-form"
                eventLabel="Email Address*"
                form={form}
            />
            <Field
                {...fields.password}
                eventAction="login-form"
                eventLabel="Password*"
                form={form}
            />
        </Stack>
    )
}

LoginFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default LoginFields
